import request from '@/utils/request'

const sellControlTableApi = {
  getByBuildingId: '/api/sellControlTable/building',
  saveOrUpdate: '/api/sellControlTable/saveOrUpdate',
  getByBuildingIds: '/api/sellControlTable/building/list',
}

export function getByBuildingId (buildingId) {
  return request({
    url: `${sellControlTableApi.getByBuildingId}/${buildingId}`,
    method: 'get'
  })
}

export function getByBuildingIds(buildingIds) {
  return request({
    url: sellControlTableApi.getByBuildingIds,
    method: 'post',
    data: buildingIds
  })
}